const replaceNewline = (string, replacement="<br />") => string.replace(/[\n\r]/g, replacement)

export default replaceNewline